import { useLocation } from 'react-router-dom';
import { useActiveEntity } from '../hooks/useActiveEntity';

/** Pages whose content belongs to the active entity (spec §7). */
const SCOPED = [/^\/portal\/?$/, /^\/portal\/documents/, /^\/portal\/queries/, /^\/portal\/book-appointment/];
/** Pages about the person, which never change with the switch (BR-CP-HOME-008) — My details included (DL-CP-19). */
const OWN = [/^\/portal\/onboarding/, /^\/portal\/comms-preferences/, /^\/portal\/my-details/];

/**
 * Spec §7 — states in words which entity the page shows, so the switch is never conveyed by the topbar alone
 * (WCAG 2.1 AA). Nothing on the Sign page, which lists the person's requests across every entity (§4.9).
 */
export function ActiveEntityBanner() {
  const { pathname } = useLocation();
  const { active, options } = useActiveEntity();
  if (!active) return null;

  const cls = 'mb-4 rounded-md bg-[var(--accent-light)] px-3 py-2 text-sm text-[var(--text2)] break-words';

  if (SCOPED.some((r) => r.test(pathname))) {
    return (
      <p role="status" className={cls}>
        Viewing <strong className="text-[var(--text1)]">{active.displayName}</strong>
        {active.entityType && active.entityType !== 'Unknown' ? ` (${active.entityType})` : ''}
        {options.length > 1 ? ' — change it from the top bar.' : ''}
      </p>
    );
  }

  if (OWN.some((r) => r.test(pathname)) && !active.isOwn) {
    return (
      <p role="status" className={cls}>
        These are your own details. They do not change with the entity you are viewing.
      </p>
    );
  }

  return null;
}
